<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import uploadFile from "@/views/components/common/form/uploadFile.vue";
import { Input, Row, Col, ButtonGroup, Button } from "view-design";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "skill",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "标题",
          name: "title",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "副标题",
          name: "stitle",
          value: "",
          type: "input",
          // rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "技术分类",
          name: "category_id",
          value: "",
          type: "skillcategory_id",
          multiple: true,
          dropList: [],
        },
        {
          label: "用户标签",
          name: "tag_ids",
          value: "",
          type: "tag_ids",
          multiple: true,
          dropList: [],
        },
        {
          label: "封面图",
          name: "image",
          value: "",
          type: "image",
          desc: "图片尺寸最低977*505像素",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "是否展示",
          name: "status",
          value: 1,
          type: "switch",
          trueValue: 1,
          falseValue: 0,
        },
        {
          label: "内容集合",
          name: "Materials_arr",
          value: "",
          type: "render",
          props: { label: "传入的label" }, // 需要传递的属性
          render: (h, cxt, props, value) => {
            // console.log("getRender", h, cxt, props, value);
            // console.log("Material_ll", this.Material_ll);
            if (!this.Material_ll || this.Material_ll.length == 0) {
              if (value) {
                this.Material_ll = value || [];
              }
              // console.log("Material_ll value", this.Material_ll, value);
            }
            return (
              <div>
                {this.Material_ll.map((item, index) => (
                  <Row>
                    <Col span={5} style="margin:20px 0 0 0">
                      <div>图片{index+1}</div>
                    </Col>
                    <Col span={18} style="margin:20px 0 0 0">
                      <uploadFile
                        value={item.coverUrl}
                        on-input={(val) => {
                          console.log("on-input val", val);
                          item.coverUrl = val;
                        }}
                        type="image"
                        disabled="v.disabled"
                      ></uploadFile>
                    </Col>
                    <Col span={5} style="margin:20px 0 0 0">
                      <div>简介{index+1}</div>
                    </Col>
                    <Col span={18} style="margin:20px 0 0 0">
                      <Input
                        type="textarea"
                        maxlength="500"
                        show-word-limit
                        rows="8"
                        value={item.name}
                        on-input={(val) => {
                          console.log("on-input val", val);
                          item.name = val;
                        }}
                        size="default"
                        placeholder="请输入简介"
                        style="width:60%"
                      ></Input>
                    </Col>
                    <Col span={5} style="margin:20px 0 0 0">
                      <div>视频{index+1}</div>
                    </Col>
                    <Col span={18} style="margin:20px 0 0 0">
                      <uploadFile
                        value={item.url}
                        on-input={(val) => {
                          console.log("on-input val", val);
                          item.url = val;
                        }}
                        type="video"
                        disabled="v.disabled"
                      ></uploadFile>
                    </Col>

                    <Col span={5}>
                      <ButtonGroup size="small" style="margin-left:10px;">
                        <Button
                          onClick={() => {
                            console.log(index);
                            item.index = index;
                            // this.Material_ll.splice(index, 1);
                            this.delete(item);
                          }}
                          type={"error"}
                          style=""
                        >
                          移除
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                ))}
                <Row>
                  <Col>
                    <Button
                      onClick={() => {
                        let isAddVal = 1;
                        let index = 0;
                        this.Material_ll.map((item) => {
                          if (
                            item.coverUrl &&
                            item.name &&
                            item.url
                            //  && item.docUrl
                          ) {
                            isAddVal = 2;
                            index = index + 1;
                          } else {
                            isAddVal = 1;
                            this.$Message.error("请完整填写上一条内容");
                          }
                        });
                        if (isAddVal == 2 && index == this.Material_ll.length) {
                          this.Material_ll.push({
                            name: "",
                            url: "",
                            coverUrl: "",
                            tagName: "",
                            tag: "",
                            // docUrl: "",
                          });
                        }
                      }}
                      type={"primary"}
                      size="small"
                      style="margin-left:10px;"
                    >
                      添加
                    </Button>
                  </Col>
                </Row>
              </div>
            );
          },
        },
        
        // {
        //   label: "简介",
        //   name: "content",
        //   value: "",
        //   type: "textarea",
        //   maxlength: 500,
        //   rules: [{ type: "string", max: 500, message: "超过最大长度" }],
        // },
        // {
        //   label: "视频",
        //   name: "video",
        //   value: "",
        //   type: "video",
        //   rules: [{ required: false, trigger: "blur" }],
        // },
        // { label: '详情', name: 'detail', value: '', type: 'ueditor' },
        
      ],
      forms: {},
      Material_ll: [
        {
          name: "",
          url: "",
          coverUrl: "",
        },
      ],
    };
  },
  created() {
    // this.loadLevelData();
    // this.gettagsDrop();
  },
  methods: {
    delete(val) {
      this.$Modal.confirm({
        title: "移除内容",
        width: "400px",
        closable: true,
        showOk: true,
        cancelText: "取消",
        content: "是否要移除？移除后将无法恢复",
        onOk: () => {
          // let id = val.fileId;
          let index = val.index;
          this.Material_ll.splice(index, 1);
        },
        onCancel: () => {
          this.$Modal.remove();
        },
      });
    },
    initData() {
      // 加载详情数据
      $form.initData(this, {}, (res) => {
        if (res) {
          this.forms = res;
          this.$forceUpdate();
          if (this.forms.ext_a3) {
            this.Material_ll = JSON.parse(this.forms.ext_a3);
            if (this.Material_ll.length == 0) {
              this.Material_ll = [
                {
                  name: "",
                  url: "",
                  coverUrl: "",
                },
              ];
            }
            // console.log(" this.Material_ll this.Material_ll", this.Material_ll);
          }
          if (this.forms.category_id) {
            this.forms.category_id = this.forms.category_id.split(",");
          }
        }
      });
    },
    loadLevelData() {
      let q = {
        model: "skill",
      };
      $utils.api.load(`categorynotPagelist`, q).then((res) => {
        console.log(res, "222222");
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.category_id.toString();
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "category_id") {
              this.items[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
          console.log("dropList category_id", dropList);
        }
      });
    },
    gettagsDrop() {
      let q = {};
      $utils.api.load(`UserTagnotPagelist`, q).then((res) => {
        console.log(res, "222222");
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id.toString();
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "tag_ids") {
              this.items[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
          console.log("dropList tag_ids", dropList);
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      // 数组转JSON
      this.forms.ext_a3 = JSON.stringify(this.Material_ll);
      // console.log(" this.forms", this.forms,this.Material_ll)
      this.$refs.form.validate((valid) => {
        console.log("handleSubmit forms", valid, this.forms);
        if (valid) {
          this.forms.tag_ids = (this.forms.tag_ids || []).join(",");
          this.forms.category_id = (this.forms.category_id || []).join(",");
          $form.handleSubmit(this);
        }
      });
    },
  },
};
</script>
